import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { FormInput } from '../../../components/FormInput';
import { checkDpSuccess } from '../../../utility/service/tool-service';
import { Controller } from 'react-hook-form';
import { classNames } from 'primereact/utils';
import { Dropdown } from 'primereact/dropdown';
const AddSubAcct = ({
    register,
    errors,
    roleList,
    control
}) => {
    const { t } = useTranslation();




  useEffect(()=>{

  },[])

  return (
    <div className="grid">
        <div className="col-12 flex">

            <FormInput
                wrapperClass='w-full'
                register={register}
                errors={errors}
                id="acct"
                type="text"
                labelText={t('account')}
                labelClass="control-label required"
                rules={{required: { value: true, message: t('validation.required') }}}
              />
                <div className="form-label-has-top-space">
                    <label htmlFor="acct">@tpisoftware.com</label>
                </div>
              
        </div>
        <div className="col-12">
            <FormInput
                register={register}
                errors={errors}
                id="userName"
                type="text"
                labelText={t('user_name')}
                labelClass="control-label required"
                rules={{required: { value: true, message: t('validation.required') }}}
              />
        </div>
        {/* <div className="col-12">
            <FormInput
                register={register}
                errors={errors}
                id="phone"
                type="tel"
                labelText={t('tel')}
                labelClass="control-label required"
                rules={{required: { value: true, message: t('validation.required') }}}
              />
        </div> */}
        <div className='col-12'>
              <label
                htmlFor="add_roleSeq"
                className="form-label required">
                {t('role')}
              </label>
              <Controller
                name="add_roleSeq"
                control={control}
                rules={{ required: { value: true, message: t('validation.required') } }}
                render={({ field, fieldState }) => (
                  <Dropdown
                    filter

                    optionLabel="value"
                    optionValue="label"
                    value={field.value}
                    virtualScrollerOptions={{ itemSize: 40 }}
                    defaultValue={""}
                    placeholder={t("plz_chs")}
                    name="add_roleSeq"
                    control={control}
                    options={roleList}
                    className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                    onChange={(event) => {
                      field.onChange(event.value);
                    }}
                  />
                )}
              />
            </div>


    </div>
  )
}

export default AddSubAcct